export function removeGnokenSuffix(phrase) {
	const gnokenRegex = new RegExp(/ GNOKEN/i);
	return phrase.replace(gnokenRegex, "");
}
